export const SERVICE_PROVIDERS = {
  RISK_THEORY: 'riskTheory',
  WEBFLEET: 'webfleet',
  RADIUS: 'radius',
  EDVIR: 'edvir',
  CLUTCH: 'clutch',
  SPIREON: 'spireon',
  TP: 'tp',
  NAUTO: 'nauto',
  AZUGA: 'azuga',
  AT: 'at',
  SIMPLEX: 'simplex',
  EM: 'em',
  GS: 'gs',
  ELDX: 'eldx',
  TRACKIT: 'trackit',
  FT: 'ft',
  HCSS: 'hcss',
  PATRIOT: 'patriot',
  TRACKON: 'trackon',
};
